// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sitenav-module--wrapper--1ulZF","hamburger":"sitenav-module--hamburger--FUMRc","nav":"sitenav-module--nav--1Kz3R","navMenu":"sitenav-module--nav-menu--2_byB"};